import { GoogleMap, InfoWindow, LoadScript, MarkerF } from "@react-google-maps/api";

import SearchBar from "./components/SearchBar";
import ExpandedSearch from "./components/ExpandedSearch";
import { useState } from "react";

const googleMapsApiKey1 = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? "";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = {
  lat: 33.8645,
  lng: -118.2552,
};

function App() {
  const nodesOnly = [

    { id: 1, lat: 33.865638419513644, lng: -118.25545728206636, icon: "", label: "Marker1" },
    { id: 2, lat: 33.86512617043824, lng: -118.25546264648439, icon: "", label: "Marker2" }
  ]

  const [results, setResults] = useState<any[]>([]);
  const [infoPosition, setInfoPosition] = useState(center);
  const [infoContent, setInfoContent] = useState(
    "Click the map to get Lat/Lng!"
  );

  const handleClick = (e) => {
    const latLng = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };

    setInfoPosition(latLng);
    setInfoContent(JSON.stringify(latLng, null, 2));
  };

  const handleSelect = (value: string) => {
    setResults([]);
  };

  return (

    <div className="main-container">
      <div className="search-container">
        <SearchBar setResults={setResults} />
        {results.length > 0 ? (
          <ExpandedSearch results={results} onSelect={handleSelect} />
        ) : null}
      </div>

      <div className="google-map-container">
        <LoadScript googleMapsApiKey={googleMapsApiKey1}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={10}
            onClick={handleClick}
          >
            {nodesOnly.map((target) =>
              <MarkerF
                key={target.id}
                position={{ lat: target.lat, lng: target.lng }}
                label={target.label}
                clickable={true}
              />
            )
            }
            <InfoWindow position={infoPosition}>
              <pre style={{ margin: 0 }}>{infoContent}</pre>
            </InfoWindow>

            <MarkerF
              position={center}
              label={"string"}
              clickable={true}
            />
          </GoogleMap>
        </LoadScript>
      </div>
    </div>

  );
}

export default App;
